import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import DocumentIcon from 'images/document.svg';
import CalendarIcon from 'images/calendar.svg';
import {
  Status,
  Label,
  Value,
  GreenBackground,
  AccordionDetails,
  OpcaoButton,
  WhiteBold,
  AcordoButton,
  AlertBannerContainer,
  AlertBannerContent,
  AlertTitle
} from './styles';
import { formatToPercent, getFormattedDate, getMoney, moneyAndPercent } from 'utils/transform';
import {
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
  Select,
  useMediaQuery,
  Checkbox,
  Button } from '@mui/material';
import { useAuth } from 'contexts/auth';
import { Else, If, Then, When } from 'react-if';
import WarningPrimary from 'images/warning-primary.svg';
import {
  TIPO_DESCONTO_MOMETARIO,
  TIPO_DESCONTO_PERCENTUAL,
} from 'utils/constants';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { IDivida } from 'interfaces/Divida';
import {
  IBuscaOpcaoPagamento,
} from 'interfaces/BuscaOpcaoPagamento';
import { buscaOpcaoPagamentoService } from 'services/buscaOpcaoPagamento/buscaOpcaoPagamento';
import { ICustomizacao } from 'interfaces/Customizacao';
import { buscaCustomService } from 'services/buscaCustomizacao/buscaCustomizacao';
import { HelperButton, HelperContainer, HelperText } from './styles';
import { useParams } from 'react-router-dom';
import { useTracking } from 'contexts/tracking';
import { AcaoEvento } from 'services/TrackingService';

const CustomConsolidateChip = styled(Box)`
  background-color: #C6E1C5;
  color: #0F570E;
  display: flex;
  padding: 3px;
  border-radius: 16px;
  justify-content: flex-start;
  margin-left: 10px;
  width: 180px;
  align-items: center;
`;

const CustomWarningChip = styled(Box)`
  background-color: ${({ theme }: any) => theme.palette.chips.primary.background};
  color: ${({ theme }: any) => theme.palette.chips.primary.color};
  display: flex;
  padding: 5px;
  border-radius: 16px;
  justify-content: space-between;
  margin-top: 5px;
`;

interface IDividaItemProps {
  item: IDivida | null;
  itemIndex: number;
  onClickParcelamento: any;
  onClickFirmarAcordo: any;
  onClickEnviarAcordo: any;
  usaResumoApi: boolean;
  opcaoHandleChange: any;
  onClickRegularizar: any;
}

export default function DividaItem({
  item,
  itemIndex,
  onClickParcelamento,
  onClickFirmarAcordo,
  onClickEnviarAcordo,
  usaResumoApi,
  opcaoHandleChange,
  onClickRegularizar,
}: IDividaItemProps) {
  const isDesktop = useMediaQuery((theme: any) => theme?.breakpoints?.up('sm'));
  const isMobile = useMediaQuery((theme: any) =>
    theme?.breakpoints?.down('sm'),
  );
  const { user, bank, dividasAuthContext, setDividasAuthContext } = useAuth();
  const [opcao, setOpcao] = useState<IBuscaOpcaoPagamento | null>(null);
  const [recalculaDivida, setRecalculaDivida] = useState('Firmar acordo');
  const [loading, setLoading] = useState(false);
  const [showHelper, setShowHelper] = useState(false);
  const [custom, setCustom] = useState<ICustomizacao>();
  const [contratosEscolhidos, setContratosEscolhidos] = useState(
    item?.contratos?.map(contrato => contrato?.numero),
  );
  const [dividaDocumento] = useState(item?.documento);
  const [searchPaymentOptionsCounter, setSearchPaymentOptionsCounter] = useState(0);
  const { trackId } = useParams<{ trackId: string | undefined }>()
  const { sendTracking } = useTracking();

  const opcaoResumo = useMemo(
    () =>
      Array.isArray(opcao?.opcoesPagamento) ? opcao?.opcoesPagamento[0] : null,
    [opcao],
  );

  const [selectedDate, setSelectedDate] = useState<Date | null>(
    (!!opcao &&
      !!opcao?.opcoesPagamento &&
      opcao?.opcoesPagamento[0]?.dataVencimento) ||
    null,
  );
  const handleDateChange = (date: Date | any) => {
    setRecalculaDivida('Recalcular acordo');
    setSelectedDate(date);
  };

  const handleCheckBoxChange = (contratoNumero: string) => {
    const contratos = !!contratosEscolhidos
      ? [...contratosEscolhidos]
      : ([] as string[]);
    const index = contratos.findIndex(_ => _ === contratoNumero);
    if (index >= 0 && contratos?.length > 1) {
      contratos.splice(index, 1);
    } else if (!contratos?.includes(contratoNumero)) {
      contratos.push(contratoNumero);
    }
    setContratosEscolhidos(contratos);
    setRecalculaDivida('Recalcular acordo');
  };

  const exibirValorTotal = item?.exibirValorTotal
  const exibirDescontoMonetario = item?.exibirDescontoMonetario
  const exibirDescontoPercentual = item?.exibirDescontoPercentual

  const exibirDesconto = () => (!!opcaoResumo?.desconto) &&
    (opcaoResumo?.desconto > 0) &&
    (exibirDescontoMonetario || exibirDescontoPercentual);

  const valorDesconto = useMemo(() => {
    if (!opcaoResumo) return;

    if (exibirDescontoPercentual && !exibirDescontoMonetario) {
      return formatToPercent(opcaoResumo.descontoPercentual);
    }

    if (!exibirDescontoPercentual && exibirDescontoMonetario) {
      return getMoney(opcaoResumo.descontoMonetario);
    }

    if (exibirDescontoPercentual && exibirDescontoMonetario) {
      return (
        '' +
        (moneyAndPercent(opcaoResumo.descontoMonetario, opcaoResumo.descontoPercentual)[0])
        + ' (' +
        (moneyAndPercent(opcaoResumo.descontoMonetario, opcaoResumo.descontoPercentual)[1])
        + ')'
      )
    }

  }, [opcaoResumo, exibirDescontoMonetario, exibirDescontoPercentual]);

  const valorTotalDivida = useMemo(() => {
    return (
      item?.contratos?.reduce((acc, next) => acc + Number(next?.valor), 0) || 0
    );
  }, [item]);

  const contratosObj = useMemo(() => {
    const dividasGlobal = !!dividasAuthContext
      ? [...dividasAuthContext]
      : ([] as IDivida[]);
    const index = dividasGlobal?.findIndex(
      _ => _.documento === dividaDocumento,
    );
    if (index >= 0) {
      return item?.contratos?.filter(_ =>
        contratosEscolhidos?.includes(_.numero),
      );
    }
    return dividasGlobal[index]?.contratos;
  }, [item, contratosEscolhidos, dividasAuthContext, dividaDocumento]);

  const valorPercentualDesconto = useMemo(() => {
    if (!opcaoResumo) return;

    if (item?.tipoDesconto === TIPO_DESCONTO_PERCENTUAL) {
      return formatToPercent(opcaoResumo.desconto);
    }

    if (item?.tipoDesconto === TIPO_DESCONTO_MOMETARIO) {
      return getMoney(opcaoResumo.desconto);
    }
  }, [opcaoResumo, item]);

  const buscaOpcaoPagamento = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await buscaOpcaoPagamentoService({
        Crm: item?.crm,
        Carteira: item?.carteiraId,
        Contrato: usaResumoApi ? null : item?.numero,
        Contratos: usaResumoApi ? contratosEscolhidos : null,
        CNPJ_CPF: user?.cnpJ_CPF,
        CodigoOpcao: '0',
        DataVencimento: selectedDate ?? null,
        ValorEntrada: null,
      });

      if (!data?.sucesso) {
        toast.error(data?.msgInsucesso || 'Erro ao buscar opção de pagamento');
      } else {
        setOpcao(data);
        setDividasAuthContext(
          dividasAuthContext?.map(div => {
            if (div.documento === dividaDocumento) {
              return {
                ...div,
                dataVencimento: selectedDate,
                contratos: !!contratosObj ? [...contratosObj] : [],
              };
            } else {
              return div;
            }
          }),
        );
        setRecalculaDivida('Firmar acordo');
      }
    } finally {
      setLoading(false);
    }
  }, [
    contratosEscolhidos,
    contratosObj,
    dividaDocumento,
    usaResumoApi,
    item,
    selectedDate,
    user,
    dividasAuthContext,
    setDividasAuthContext,
  ]);

  useEffect(() => {
    if (!!opcao?.opcoesPagamento && !selectedDate)
      setSelectedDate(opcao?.opcoesPagamento[0]?.dataVencimento as Date);
  }, [opcao, selectedDate]);

  useEffect(() => {
    if (!item || !user || searchPaymentOptionsCounter === 2) return;
    if (opcao === null && !loading) {
      buscaOpcaoPagamento();
      setSearchPaymentOptionsCounter(searchPaymentOptionsCounter + 1);
    }
  }, [item, user, buscaOpcaoPagamento, opcao, loading]);

  useEffect(() => {
    opcaoHandleChange(opcao);
  }, [opcao, opcaoHandleChange]);

  useEffect(() => {
    async function buscaCustomizacao() {
      const { data: newCustom } = await buscaCustomService({
        crms: item?.crm,
        carteiraId: item?.carteiraId,
      })
      setCustom(newCustom);
    }
    buscaCustomizacao();
  }, []);

  const exibirContrato = (event: React.ChangeEvent<{}>, expanded: boolean) => {
    expanded && sendTracking({
      trackId,
      acao: AcaoEvento.VisualizarOpcoesPagamento,
      cpfCnpj: user?.cnpJ_CPF,
      contratoId: item?.numero,
      crm: item?.crm,
      carteiraId: item?.carteiraId
    });
  }

  return (
    <Box mb={2}>
      <Accordion onChange={exibirContrato} style={{ backgroundColor: item?.dividaConsolidada ? '#E5E5E5' : '' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon color="primary" />}>
          <Box>
            <Box display="flex" alignItems="center">
              <Box mr={2}>
                <Status color="primary">
                  <strong>Dívida ativa grupo {itemIndex + 1}</strong>
                </Status>
              </Box>
              <Box mr={1}>
                <img
                  style={{ marginBottom: 2 }}
                  src={DocumentIcon}
                  alt="Documento"
                />
              </Box>
              <Status>
                <span>
                  {item?.contratos?.length} Contrato
                  {Number(item?.contratos?.length) > 1 && 's'}
                </span>
              </Status>
            </Box>
            {
              custom?.ImagemCarteira !== '' && !!custom?.ImagemCarteira ?
                <img
                  width='50px'
                  src={custom?.ImagemCarteira}>
                </img>
                :
                <>
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 28 }} variant="h6">
                      <strong>{bank?.financeira}</strong>
                    </Typography>
                    {item?.dividaConsolidada && (
                      <CustomConsolidateChip>
                        <AutoAwesomeMotionIcon />
                        <Box style={{ display: 'flex', marginLeft: '3px' }}>
                          <Typography variant="caption" style={{ fontWeight: 500 }}>
                            Dívida consolidada
                          </Typography>
                          <HelperButton
                            onMouseOver={() => {
                              setShowHelper(true);
                            }}
                            onMouseOut={() => setShowHelper(false)}
                          >
                            <span>?</span>
                          </HelperButton>
                          {showHelper && (
                            <HelperContainer>
                              <HelperText>Esta opção permite fazer o acordo das dívidas em um único pagamento.</HelperText>
                            </HelperContainer>
                          )}
                        </Box>
                      </CustomConsolidateChip>
                    )}
                  </Box>
                </>
            }
            {(exibirValorTotal && item?.permiteNegociacao && valorTotalDivida > 0) && (
              <Box display="flex" flexWrap="wrap" alignItems="center">
                <Box mr={2}>
                  <Typography variant="body2">Valor total da dívida</Typography>
                </Box>
                <Typography variant="body1" color="primary">
                  {getMoney(valorTotalDivida)}
                </Typography>
              </Box>
            )}
          </Box>
        </AccordionSummary>
        {custom?.InformacaoAdicional && (
          <AccordionSummary>
            <CustomWarningChip>
              <img
                src={WarningPrimary}
                alt="Warning"
                style={{ marginRight: 10 }}
              />
              <Box>
                <Typography variant="caption" style={{ fontWeight: 500 }}>
                  {custom?.InformacaoAdicional}
                </Typography>
              </Box>
            </CustomWarningChip>
          </AccordionSummary>
        )}
        <AccordionDetails>
          {!!item?.permiteDesagrupamentoContratos && (
            <Box display="flex" flexWrap="wrap" alignItems="center">
              <Box p={2}>
                <Typography
                  variant="body2"
                  color="secondary"
                  style={{ fontWeight: 500 }}
                >
                  Você pode selecionar um ou mais contratos da sua dívida.
                </Typography>
              </Box>
            </Box>
          )}
          {item?.contratos?.map((contrato, contratoIndex) => (
            <Box p={2} key={contrato.numero} width="100%">
              {!!usaResumoApi && !!item.permiteDesagrupamentoContratos && (
                <Checkbox
                  size="small"
                  checked={contratosEscolhidos?.includes(contrato?.numero)}
                  onChange={() =>
                    handleCheckBoxChange(
                      !!contrato?.numero ? contrato?.numero : '',
                    )
                  }
                />
              )}
              <Grid container alignItems="stretch">
                {!!contrato?.produto && (
                  <Grid item xs={6} sm={4}>
                    <Box>
                      <Label dividaConsolidada={item?.dividaConsolidada}>Produto:</Label>
                      <Value>{contrato.produto}</Value>
                    </Box>
                  </Grid>
                )}
                <Grid item xs={6} sm
                  style={{
                    display: 'flex',
                    justifyContent: isDesktop ? "flex-start" : "flex-end",
                    textAlign: "end"
                  }}
                >
                  {!!contrato?.documento && (

                    <Box>
                      <Label dividaConsolidada={item?.dividaConsolidada}>Contrato:</Label>
                      <Value>{contrato.documento}</Value>
                    </Box>
                  )}
                </Grid>
                {
                  !!contrato?.valorOriginalDivida && (
                    <Grid item xs={6} sm>
                      <Box>
                        <Label dividaConsolidada={item?.dividaConsolidada}>Valor original:</Label>
                        <Value>{getMoney(contrato.valorOriginalDivida)}</Value>
                      </Box>
                    </Grid>
                  )
                }
                <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                  {!!contrato?.valor && (
                    <Grid item>
                      <Label dividaConsolidada={item?.dividaConsolidada}>
                        {(custom && item?.permiteNegociacao) && (
                          custom.DividaItem
                        )}
                      </Label>
                      <Value
                        style={{
                          fontSize: 18,
                          textAlign: isDesktop ? 'right' : 'left',
                        }}
                      >
                        {(custom && item?.permiteNegociacao) && (
                          getMoney(contrato.valor)
                        )}
                      </Value>
                    </Grid>
                  )}
                </Box>
              </Grid>
              <Grid container>
                {!!item?.valorDoLimite && item?.tipoContrato === "REORGPF" && (
                  <Grid item xs={6} sm={6}>
                    <Box>
                      <Label dividaConsolidada={item?.dividaConsolidada}>Valor do limite:</Label>
                      <Value>{getMoney(item.valorDoLimite)}</Value>
                    </Box>
                  </Grid>
                )
                }
                {!!item?.valorDoLimiteEmUso && item?.tipoContrato === "REORGPF" && (
                  <Grid item xs={6} sm={6}
                    style={{
                      display: 'flex',
                      justifyContent: "flex-end",
                      textAlign: 'end'
                    }}
                  >
                    <Box>
                      <Label dividaConsolidada={item?.dividaConsolidada}>Valor do limite em uso:</Label>
                      <Value>{getMoney(item.valorDoLimiteEmUso)}</Value>
                    </Box>
                  </Grid>
                )
                }
              </Grid>
              <Grid container>
                <When condition={!!contrato?.dataContratacao}>
                  <Grid item xs={6} sm={3}>
                    <Box>
                      <Label dividaConsolidada={item?.dividaConsolidada}>Contratação:</Label>
                      <Value>
                        {getFormattedDate(contrato?.dataContratacao) || '-'}
                      </Value>
                    </Box>
                  </Grid>
                </When>
                <Grid item xs={6} sm={3}>
                  <Box>
                    {!!contrato?.dataAtraso && (
                      <>
                        <Label dividaConsolidada={item?.dividaConsolidada}>Atraso:</Label>
                        <Value>
                          {getFormattedDate(contrato?.dataAtraso)}
                        </Value>
                      </>
                    )}
                  </Box>
                </Grid>
                <When condition={!contrato.dataContratacao}>
                  <Grid item xs={6} sm={3} />
                </When>
                <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                  <Grid item xs={6} />
                  <Grid item xs={6}>
                    <Label dividaConsolidada={item?.dividaConsolidada}>
                      {(custom && item?.permiteNegociacao) && (
                        custom.DividaItem
                      )}
                    </Label>
                    <Value
                      style={{
                        fontSize: 18,
                        textAlign: isDesktop ? 'right' : 'left',
                      }}
                    >
                      {(custom && item?.permiteNegociacao) && (
                        getMoney(contrato.valor)
                      )}
                    </Value>
                  </Grid>
                </Box>
                <When condition={!!contrato.diasAtraso}>
                  <Grid item xs={6} sm={3}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems={'flex-end'}
                    >
                      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                        <Label style={{ marginBottom: 2 }}>&nbsp;</Label>
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        alignContent="center"
                      >
                        <Box mr={1}>
                          <img src={CalendarIcon} alt="Calendário" />
                        </Box>
                        <Value style={{ marginBottom: 0 }}>
                          Atraso:{' '}
                          <span style={{ fontWeight: 'lighter' }}>
                            {contrato.diasAtraso} dias
                          </span>
                        </Value>
                      </Box>
                    </Box>
                  </Grid>
                </When>
              </Grid>
              {Number(item?.contratos?.length) - 1 !== contratoIndex && (
                <Divider />
              )}
            </Box>
          ))}
          {loading || !!(opcao?.opcoesPagamento && opcao?.opcoesPagamento?.length > 0) ? (
            item?.permiteNegociacao ? (
              <GreenBackground>
                <Grid
                  container
                  wrap="wrap"
                  direction={isMobile ? 'column' : 'row'}
                  spacing={2}
                >
                  <If condition={!loading}>
                    <Then>
                      <When condition={Number(opcao?.opcoesPagamento?.length) > 1}>
                        <Grid item xs>
                          <Typography
                            color="textSecondary"
                            style={{ fontSize: 18, fontWeight: 500 }}
                          >
                            {!exibirDesconto() || (valorPercentualDesconto && valorPercentualDesconto === 'R$ 0,00') ? (
                              custom?.DividaPagamentoSemDesconto
                            ) :
                              exibirDesconto() && (
                                <>
                                  {custom?.DividaPagamentoComDesconto1}{' '}
                                  <WhiteBold>{valorDesconto}</WhiteBold>{custom?.DividaPagamentoComDesconto2}
                                </>
                              )}
                            {Number(opcaoResumo?.parcelas?.length) > 1 && !!opcaoResumo?.texto && (
                              <>
                                <br /> <br /> {opcaoResumo?.texto}
                                {opcaoResumo?.texto.charAt(
                                  opcaoResumo?.texto.length - 1,
                                ) === '.' || '.'}
                              </>
                            )}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Box display="flex" flexDirection="column">
                            <OpcaoButton
                              disabled={recalculaDivida === 'Recalcular acordo'}
                              onClick={() => {
                                onClickParcelamento({ item, opcao });
                              }}
                            >
                              Opções de pagamento
                            </OpcaoButton>
                          </Box>
                        </Grid>
                      </When>
                      <Grid item xs={12}>
                        <Box
                          width="100%"
                          display="flex"
                          alignItems="center"
                          mt={2}
                          mb={1}
                        >
                          <Typography
                            color="textSecondary"
                            style={{ fontSize: 18, fontWeight: 500 }}
                          >
                            Resumo
                          </Typography>
                          <Divider style={{ flexGrow: 1, marginLeft: 16 }} />
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid
                          container
                          wrap="wrap"
                          justifyContent="space-between"
                          spacing={1}
                        >
                          {opcaoResumo?.valorDivida !== 0 && (
                            <>
                              <Grid item xs={6} sm={3}>
                                <Label textSecondary semiBold>
                                  {Number(opcaoResumo?.parcelas?.length) > 1
                                    ? 'Total do Parcelamento'
                                    : custom?.TextoResumoAVista || opcaoResumo?.texto}
                                </Label>
                                <WhiteBold>
                                  {getMoney(opcaoResumo?.valorDivida)}
                                </WhiteBold>
                              </Grid>
                            </>
                          )}
                          <If condition={!!opcao?.escolherDataVencimento}>
                            <Then>
                              <Grid item xs={12} sm={3}>
                                <Label textSecondary semiBold>
                                  Selecione a data de vencimento
                                </Label>
                                <Select
                                  style={{ color: 'white' }}
                                  value={selectedDate}
                                  label={selectedDate ? getFormattedDate(selectedDate) : ''}
                                  onChange={e => handleDateChange(e?.target?.value)}
                                >
                                  {opcao?.listaDataVencimento?.map(
                                    (opt, index): any => (
                                      <MenuItem key={index} value={opt as any}>
                                        {getFormattedDate(opt)}
                                      </MenuItem>
                                    ),
                                  )}
                                </Select>
                              </Grid>
                            </Then>
                            <Else>
                              <Grid item xs={12} sm={3}>
                                <Label textSecondary semiBold>
                                  Data de vencimento
                                </Label>
                                <WhiteBold>
                                  {getFormattedDate(opcaoResumo?.dataVencimento)}
                                </WhiteBold>
                              </Grid>
                            </Else>
                          </If>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            style={{
                              marginTop: 'auto',
                              marginBottom: 4,
                            }}
                          >
                            <Box display="flex" justifyContent="flex-end">
                              {opcaoResumo && opcaoResumo.precisaDeAprovacao ? (
                                <AcordoButton
                                  onClick={() => {
                                    onClickEnviarAcordo({
                                      divida: item,
                                      opcaoPagamento: opcaoResumo,
                                    });
                                  }}
                                  fullWidth={isMobile}
                                >
                                  Enviar Acordo
                                </AcordoButton>
                              ) : (
                                <AcordoButton
                                  onClick={() =>
                                    recalculaDivida === 'Firmar acordo'
                                      ? onClickFirmarAcordo({
                                        divida: item,
                                        primeiraParcela: opcaoResumo,
                                        DataValidade: selectedDate ?? null,
                                        novaOpcao: opcao
                                      })
                                      : buscaOpcaoPagamento()
                                  }
                                  fullWidth={isMobile}
                                >
                                  {recalculaDivida}
                                  <strong>
                                    {recalculaDivida === 'Firmar acordo' &&
                                      (Number(opcaoResumo?.parcelas?.length) > 1
                                        ? `em ${opcaoResumo?.parcelas?.length} parcelas`
                                        : '')}
                                  </strong>
                                </AcordoButton>
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Then>
                    <Else>
                      <Grid item xs={12}>
                        <Box display="flex" p={2} justifyContent="center">
                          <CircularProgress style={{ color: '#fff' }} />
                        </Box>
                      </Grid>
                    </Else>
                  </If>
                </Grid>
              </GreenBackground>
            ) : (
              <Box display="flex" p={2} justifyContent="center">
                <Grid container>
                  <Grid item xs={12} sm={12} md={6}>
                    <Typography
                      gutterBottom
                      style={{ fontSize: 12, fontWeight: 500, maxWidth: 450, color: 'red' }}
                    >
                      Prezado cliente, identificamos uma dívida para seus contratos. Duvidas entrar em contato com nossos canais de atendimento:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <Box style={{ display: "flex", justifyContent: isMobile ? "flex-start" : "flex-end", marginTop: isMobile ? "6px" : "0" }}>
                      <Button
                        style={{ color: '#fff', whiteSpace: 'nowrap' }}
                        color="secondary"
                        variant="contained"
                        onClick={onClickRegularizar}
                      >
                        Canais de atendimento
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )
          ) : (
            <AlertBannerContainer>
              <AlertBannerContent>
                <Box style={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Box>
                    <img
                      src={WarningPrimary}
                      alt="Warning"
                      style={{ marginRight: 10, width: '20px' }}
                    />
                  </Box>
                  <Typography>
                    <AlertTitle isMobile={isMobile}>
                      {item?.permiteNegociacao ? "Tivemos um problema ao carregar as opções de pagamento" : "Negociação Indisponível"}
                    </AlertTitle>
                    {item?.permiteNegociacao ? (
                      <>
                        Houve um problema técnico ao carregar as opções de pagamento da dívida e estamos trabalhando para resolver.
                        Entre em contato através dos <strong>canais de atendimento</strong> para continuar com a negociação.
                      </>
                    ) : (
                      <>
                        O{Number(item?.contratos?.length) > 1 && 's'} contrato{Number(item?.contratos?.length) > 1 && 's'} exibido{Number(item?.contratos?.length) > 1 && 's'} se encontra{Number(item?.contratos?.length) > 1 && 'm'}
                        {' '} indisponíve{Number(item?.contratos?.length) > 1 ? 'is' : 'l'} para negociação atráves desse portal. Para entender melhor, entre em contato
                        atráves dos <strong>canais de atendimento</strong>.
                      </>
                    )}
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    justifyContent: `${isMobile ? 'center' : 'flex-end'}`,
                    marginTop: '7px'
                  }}
                >
                  <Button
                    style={{ color: '#fff', whiteSpace: 'nowrap', background: '#C75A5A' }}
                    variant="contained"
                    onClick={onClickRegularizar}
                  >
                    Canais de atendimento
                  </Button>
                </Box>
              </AlertBannerContent>
            </AlertBannerContainer>)}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
